import React, { useEffect, useState } from "react";
import { Card, Row, Col, Statistic, Spin, message } from "antd";
import { FileOutlined, UserOutlined, ProfileOutlined } from "@ant-design/icons";
import { getDashboardStatsApi } from "../../apiservice/ats";

const ATSDashboard = () => {
  const [loading, setLoading] = useState(false);
  const [stats, setStats] = useState({
    jobs: 0,
    candidates: 0,
    applications: 0,
    openJobs: 0,
    closedJobs: 0,
  });

  useEffect(() => {
    const loadStats = async () => {
      try {
        setLoading(true);
        const res = await getDashboardStatsApi();
        setStats(res.data.data);
        setLoading(false);
      } catch (err) {
        console.error(err);
        message.error("Failed to load dashboard stats");
        setLoading(false);
      }
    };
    loadStats();
  }, []);

  return (
    <Spin spinning={loading}>
      <Row gutter={[24, 24]}>
        <Col xs={24} sm={12} md={6}>
          <Card>
            <Statistic title="Total Jobs" value={stats.jobs} prefix={<FileOutlined />} />
          </Card>
        </Col>
        <Col xs={24} sm={12} md={6}>
          <Card>
            <Statistic title="Open Jobs" value={stats.openJobs} prefix={<FileOutlined />} />
          </Card>
        </Col>
        <Col xs={24} sm={12} md={6}>
          <Card>
            <Statistic title="Closed Jobs" value={stats.closedJobs} prefix={<FileOutlined />} />
          </Card>
        </Col>
        <Col xs={24} sm={12} md={6}>
          <Card>
            <Statistic title="Candidates" value={stats.candidates} prefix={<UserOutlined />} />
          </Card>
        </Col>
        <Col xs={24} sm={12} md={6}>
          <Card>
            <Statistic title="Applications" value={stats.applications} prefix={<ProfileOutlined />} />
          </Card>
        </Col>
      </Row>
    </Spin>
  );
};

export default ATSDashboard;
